<div class="row">
  <div class="header-container col-12">
    <h1 class="page-title">{{pageTitle}}</h1>
    <p class="description">{{pageDescription}}</p>
  </div>
</div>

@if (invoices$ | async; as invoices) {
  @if (loadingState$ | async; as loading) {
    <cx-spinner></cx-spinner>
  }
  <div class="cx-invoice-history-body">
    <!-- Select Form and Pagination Top -->
    @if (invoices.pagination.totalResults > 0 || appliedFilter;) {
      <div class="table-filter-header top row border-0">
        <button class="btn btn-action btn-white" (click)="toggleAdvancedSearch()">
          <app-custom-icons [type]="iconTypes.SEARCH"></app-custom-icons>
          {{ 'common.filters.advancedSearch' | cxTranslate}}
        </button>
        @if (showAdvancedSearch) {
          <div class="col-12 filters">
            <form [formGroup]="filtersForm" class="w-100" @fadeIn @fadeOut>
              <div class="row">
                <div class="col">
                  <div class="formGroup">
                    <label>
                      <span class="label-content">{{'common.filters.docType' | cxTranslate}}</span>
                      @if (getDocumentTypeList() | async; as documentTypeList) {
                        <div>
                          <select formControlName="documentType" class="form-control filter-select">
                            <option selected="selected" value="">
                              {{ 'common.select' | cxTranslate }}
                            </option>
                            @for (documentItemList of documentTypeList.b2bDocumentTypeList; track documentItemList) {
                              <option class="option-select"
                                [value]="documentItemList.code">
                                {{ documentItemList.name }}
                              </option>
                            }
                          </select>
                          <!--                                              <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
                        </div>
                      }
                      <!--                                              <ng-container *ngIf="getDocumentTypeList() | async as documentTypeList">-->
                      <!--                                                <ng-select-->
                      <!--                                                        formControlName="documentType"-->
                      <!--                                                        [searchable]="true"-->
                      <!--                                                        [clearable]="true"-->
                      <!--                                                        [closeOnSelect]="true"-->
                      <!--                                                        [items]="documentTypeList.b2bDocumentTypeList"-->
                      <!--                                                        bindLabel="name"-->
                      <!--                                                        bindValue="code"-->
                      <!--                                                        placeholder="{{ 'common.select' | cxTranslate}}"-->
                    <!--                                                ></ng-select>-->
                  <!--                                            </ng-container>-->
                </label>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>
                  <span class="label-content">{{'common.filters.orderNumber' | cxTranslate}}</span>
                  <input type="text" class="form-control" formControlName="orderCode" />
                </label>
              </div>
            </div>
            <div class="col date">
              <div class="form-group">
                <label>
                  <span class="label-content">{{'common.filters.startDate' | cxTranslate}}</span>
                  <app-date-picker [control]="filtersForm.get('iniDate')" (update)="updateDatepicker('iniDate')">
                  </app-date-picker>
                </label>
              </div>
            </div>
            <div class="col date">
              <div class="form-group">
                <label>
                  <span class="label-content">{{'common.filters.endDate' | cxTranslate}}</span>
                  <app-date-picker [control]="filtersForm.get('endDate')" (update)="updateDatepicker('endDate')">
                  </app-date-picker>
                </label>
              </div>
            </div>
            <div class="col action">
              <button class="btn btn-primary btn-black btn-with-icon" type="button" (click)="applyFilter()">
                <app-custom-icons [type]="iconTypes.ICON_FILTRAR"></app-custom-icons>
                {{'common.filters.filter' | cxTranslate}}
              </button>
            </div>
          </div>
        </form>
      </div>
      @if (invoices.pagination.totalPages > 1) {
        <div class="cx-invoice-history-pagination">
          <cx-pagination [pagination]="invoices.pagination" (viewPageEvent)="pageChange($event)"></cx-pagination>
        </div>
      }
    }
  </div>
}
@if (invoices.pagination.totalResults > 0) {
  <!-- TABLE -->
  @for (invoice of invoices.invoices; track invoice) {
    <table class="table cx-invoice-history-table mb-3">
      <tbody>
        <tr>
          <td class="cx-invoice-history-placed pl-md-3">
            <div class="cx-table-header-label">{{ 'myAccount.invoices.orderId' | cxTranslate }}</div>
            <span class="cx-invoice-history-value">{{ invoice?.orderNumber }}</span>
          </td>
          <td class="cx-invoice-history-placed pl-md-3">
            <div class="cx-table-header-label">{{ 'myAccount.invoices.date' | cxTranslate }}</div>
            <span class="cx-invoice-history-value">{{ invoice?.date | cxDate: 'shortDate' }}</span>
          </td>
          <td class="cx-invoice-history-amount">
            <div class="cx-table-header-label">{{ 'myAccount.invoices.amount' | cxTranslate }}</div>
            <span class="cx-invoice-history-value">{{ invoice?.invoiceItemsData?.netValue?.formattedValue }}</span>
          </td>
          <td class="cx-invoice-history-total">
            <div class="cx-table-header-label">{{ 'myAccount.invoices.total' | cxTranslate }}</div>
            <span class="cx-invoice-history-value">{{ invoice?.invoiceItemsData?.grandTotal?.formattedValue
            }}</span>
          </td>
          <td class="cx-invoice-history-doc-type">
            <div class="cx-table-header-label">{{ 'myAccount.invoices.docType' | cxTranslate }}</div>
            <span class="cx-invoice-history-value">{{ invoice?.documentType?.name }}</span>
          </td>
          <td class="cx-invoice-history-download" rowspan="2">
            @if (invoice?.documentMedia?.downloadURL) {
              <a [href]="invoice?.documentMedia?.downloadURL" target="_blank">
                <app-custom-icons [type]="iconTypes.ICON_PDF" class="medium"></app-custom-icons>
              </a>
            } @else {
              <app-custom-icons [type]="iconTypes.ICON_PDF" class="medium"
              disabled="disabled"></app-custom-icons>
            }
          </td>
          <td class="td-mobile">
            <div class="my-incidents-container">
              <div class="orderId">{{ 'myAccount.invoices.orderId' | cxTranslate }}<span
              class="cx-invoice-history-value">{{ invoice?.orderNumber }}</span>
              <div class="separator"></div>
            </div>
            <div class="date">{{ 'myAccount.invoices.date' | cxTranslate }}:<span
            class="cx-invoice-history-value">{{ invoice?.date | cxDate: 'shortDate' }}</span></div>
            <div class="amount">{{ 'myAccount.invoices.amount' | cxTranslate }}<div
            class="cx-invoice-history-value">{{ invoice?.invoiceItemsData?.netValue?.formattedValue }}</div>
          </div>
          <div class="total">{{ 'myAccount.invoices.total' | cxTranslate }}<div
          class="cx-invoice-history-value">{{ invoice?.invoiceItemsData?.grandTotal?.formattedValue }}</div>
        </div>
        <div class="docType">{{ 'myAccount.invoices.docTypeShort' | cxTranslate }}<div
        class="cx-invoice-history-value">{{ invoice?.documentType?.name }}</div>
      </div>
      <div class="download">
        @if (invoice?.documentMedia?.downloadURL) {
          <a [href]="invoice?.documentMedia?.downloadURL" target="_blank">
            <app-custom-icons [type]="iconTypes.ICON_PDF" class="medium"></app-custom-icons>
          </a>
          <a [href]="invoice?.documentMedia?.downloadURL" target="_blank" class="text">
            <div>{{ 'myAccount.invoices.download' | cxTranslate }}</div>
          </a>
        } @else {
          <app-custom-icons [type]="iconTypes.ICON_PDF" class="medium"
          disabled="disabled"></app-custom-icons>
        }
      </div>
    </div>
  </td>
</tr>
</tbody>
</table>
}
<!-- Select Form and Pagination Bottom -->
<div class="cx-invoice-history-sort bottom row">
  @if (invoices.pagination.totalPages > 1) {
    <div class="cx-invoice-history-pagination">
      <cx-pagination [pagination]="invoices.pagination" (viewPageEvent)="pageChange($event)"></cx-pagination>
    </div>
  }
</div>
} @else {
  @if (!(loadingState$ | async)) {
    <div [ngClass]="'cx-invoice-history-no-order row'">
      <div [ngClass]="'col-sm-12'">
        @if (appliedFilter) {
          <h3>{{ 'myAccount.invoices.noResultsFound' | cxTranslate }}</h3>
        } @else {
          <div>{{ 'myAccount.invoices.noOrders' | cxTranslate }}</div>
          <a [routerLink]="{ cxRoute: 'home' } | cxUrl" routerLinkActive="active" class="btn btn-primary btn-block">{{
            'myAccount.invoices.startShopping' | cxTranslate }}
          </a>
        }
      </div>
    </div>
  }
}
<!-- NO ORDER CONTAINER -->
</div>
}